export default "__VITE_ASSET__ZopTAw3U__"